import { surveyPlaceholderImg } from "assets/images";
import { DatePicker } from "components/form";
import NotFoundPlaceHolder from "components/not-found/NotFoundPlaceHolder";
import { getFromLocal } from "config/axiosInstance";
import useDebounce from "hooks/useDebounce";
import useShimmer from "hooks/useShrimmer";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GrShare } from "react-icons/gr";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getSurveySummaryListApi } from "services/analysis";
import MySurveyShrimmer from "shrimmer/Survey/MySurveyShrimmer";
import { handleEncryptionParams } from "utils/dataCipherHelper";

const SummeryTable = () => {
  //************************* Handle All State ***************************//
  const [activePage, setActivePage] = useState(1);
  const [surveySummaryTotal, setSetSummaryTotal] = useState(0);
  const [surveySummaryList, setSurveySummaryList] = useState([]);
  const [showShimmer, setShowShimmer] = useShimmer(MySurveyShrimmer);

  const [searchParams, setSearchParams] = useSearchParams();
  const [yearStartDate, setYearStartDate] = useState(new Date());
  const { t } = useTranslation();

  const debouncedValue = useDebounce(yearStartDate, 300);

  //************************ Handle All Function *************************//

  // statusHandler
  const statusHandler = (status) => {
    if (status === "draft") return "Pending";

    if (status === "completed") return "Completed";

    if (status === "ongoing") return "Ongoing";
  };

  // function for get survey summary list
  const fetchSurveySummaryListHandler = async () => {
    try {
      setShowShimmer(true);
      const reqData = {
        token: getFromLocal(),
        page: activePage,
        // month: moment(yearStartDate).format("MM"),
        // year: moment(yearStartDate).format("YYYY"),
      };

      if (yearStartDate && debouncedValue) {
        reqData.month = moment(debouncedValue).format("MM");
        reqData.year = moment(debouncedValue).format("YYYY");
      }

      // if (surveyStatus) {
      //   reqData.surveyStatus = surveyStatus;
      // }

      const responseData = await getSurveySummaryListApi(reqData);

      const {
        data: { surveyList = [], total = 0 },
        message = "",
        status,
      } = responseData;
      if (status === 200) {
        if (Number(activePage) === 1) {
          setSurveySummaryList(surveyList);
          // toastMessage(message, "success", "SurveyList");
        } else {
          setSurveySummaryList((prevList) => [...prevList, ...surveyList]);
        }
        // setSurveyList(surveyList);

        setSetSummaryTotal(total);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  const navigate = useNavigate();

  const scrollToTop = () => {
    const scrollContainer = document.querySelector(
      ".infinite-scroll-component"
    );
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
    }
    // setSurveyActivePage(1);
  };

  useEffect(() => {
    fetchSurveySummaryListHandler();

    // eslint-disable-next-line
  }, [activePage, debouncedValue]);

  // reDirect Handler
  const reDirectHandler = (item) => {
    const paramsData = {
      surveyId: item?._id,
      isAnalysis: true,
    };
    const encryptedParams = handleEncryptionParams(paramsData, searchParams);
    setSearchParams(encryptedParams);

    navigate(`/dashboard/analysis/report?${searchParams}`);
  };

  //************************* Handle HTML CODE ***************************//
  return (
    <>
      <div className="table_filter">
        <h3>{t("SURVEY_ANALYSIS.totalSurveySummary")}</h3>
        <div className="filter_button date_range_cstm">
          {/* <DatePicker
            selectsStart
            showYearPicker
            dateFormat="yyyy"
            className="mx-2"
            selected={yearStartDate}

            startDate={yearStartDate}
            onChange={(date) => setYearStartDate(date)}
          /> */}

          {/* <select className="input form-control">
            <option>September</option>
          </select> */}

          <DatePicker
            showMonthYearPicker
            dateFormat="MM/yyyy"
            selected={yearStartDate}
            onChange={(date) => {
              setActivePage(1);
              setSurveySummaryList([]);
              setYearStartDate(date);
            }}
          />
        </div>
      </div>

      <div className="table_wrap">
        <InfiniteScroll
          dataLength={surveySummaryList?.length || 0}
          next={() => setActivePage((prev) => prev + 1)}
          hasMore={surveySummaryList?.length < surveySummaryTotal}
          loader={<>{showShimmer}</>}
          // inverse={true}
          // endMessage={
          //   <p
          //     style={{ textAlign: "center", cursor: "pointer" }}
          //     onClick={scrollToTop}
          //   >
          //     <b>No more survey</b>
          //   </p>
          // }
        >
          <table className="table">
            <thead>
              <tr>
                <th className="text-center">{t("SURVEY_ANALYSIS.sno")}</th>
                <th>{t("SURVEY_ANALYSIS.referenceNumber")}</th>
                <th>{t("SURVEY_ANALYSIS.surveyName")}</th>
                <th className="text-center">
                  {t("SURVEY_ANALYSIS.totalQuestion")}
                </th>
                <th className="text-center">
                  {t("SURVEY_ANALYSIS.startDate")} -
                  {t("SURVEY_ANALYSIS.endDate")}
                </th>
                <th className="text-center">{t("SURVEY_ANALYSIS.response")}</th>
                <th className="text-center">{t("SURVEY_ANALYSIS.status")}</th>
                <th className="text-center">{t("SURVEY_ANALYSIS.action")}</th>
              </tr>
            </thead>

            <tbody>
              {surveySummaryList?.length > 0 ? (
                surveySummaryList?.map((el, i) => (
                  <tr key={el?._id}>
                    <td className="text-center">
                      <span className="sr_number">{i + 1}</span>
                    </td>
                    <td>{el?.surveyReferenceNumber || "------"}</td>
                    <td>{el?.title || "------"}</td>
                    <td className="text-center">{el?.totalMcqs || "------"}</td>
                    <td className="text-center">
                      {`${moment(el?.createdAt).format("D.MM.YYYY")} - ${moment(
                        el?.expiryDate
                      ).format("D.MM.YYYY")}`}
                    </td>
                    <td className="text-center">{el?.totalParticipants}</td>
                    <td className="text-center">
                      <span className={`tag status ${el?.surveyStatus}`}>
                        {statusHandler(el?.surveyStatus)}
                      </span>
                    </td>

                    {/* <td className="text-center">
                      {el?.surveyStatus !== "draft" && (
                        <button
                          type="button"
                          className="action_button"
                          onClick={() => reDirectHandler(el)}
                        >
                          <GrShare />
                        </button>
                      )}
                    </td> */}

                    <td className="text-center">
                      <button
                        type="button"
                        className="action_button"
                        onClick={() => reDirectHandler(el)}
                        disabled={el?.surveyStatus === "draft"}
                      >
                        <GrShare />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8}>
                    <NotFoundPlaceHolder
                      className="mySurveyList"
                      title={t("SURVEY_ANALYSIS.surveyListNotFound")}
                      placeHolderImage={surveyPlaceholderImg}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </>
  );
};

export default SummeryTable;

// const testData = () => {
//   return (
//     <InfiniteScroll
//       dataLength={surveySummaryList?.length || 0}
//       next={() => setActivePage((prev) => prev + 1)}
//       hasMore={surveySummaryList?.length < surveySummaryTotal}
//       loader={<div className="card_wrap">{showShimmer}</div>}
//       // inverse={true}
//       // endMessage={
//       //   <p
//       //     style={{ textAlign: "center", cursor: "pointer" }}
//       //     onClick={scrollToTop}
//       //   >
//       //     <b>No more survey</b>
//       //   </p>
//       // }
//     >
//       <div className="table_wrap">
//         <table className="table">
//           <thead>
//             <tr>
//               <th className="text-center">S. No.</th>
//               <th>Reference No.</th>
//               <th>Survey Name</th>
//               <th className="text-center">Total Questions</th>
//               <th className="text-center">State Date - End Date</th>
//               <th className="text-center">Responses</th>
//               <th className="text-center">Status</th>
//               <th className="text-center">Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {showShimmer ||
//               (surveySummaryList?.length > 0 ? (
//                 surveySummaryList?.map((el, i) => (
//                   <tr key={el?._id}>
//                     <td className="text-center">
//                       <span className="sr_number">{i + 1}</span>
//                     </td>
//                     <td>{el?.surveyReferenceNumber || "------"}</td>
//                     <td>{el?.surveyCategory?.name || "------"}</td>
//                     <td className="text-center">{el?.totalMcqs || "------"}</td>
//                     <td className="text-center">
//                       {`${moment(el?.createdAt).format("D.MM.YYYY")} - ${moment(
//                         el?.expiryDate
//                       ).format("D.MM.YYYY")}`}
//                     </td>
//                     <td className="text-center">{el?.totalParticipants}</td>
//                     <td className="text-center">
//                       <span className={`tag status ${el?.surveyStatus}`}>
//                         {statusHandler(el?.surveyStatus)}
//                       </span>
//                     </td>

//                     {/* <td className="text-center">
//                       {el?.surveyStatus !== "draft" && (
//                         <button
//                           type="button"
//                           className="action_button"
//                           onClick={() => reDirectHandler(el)}
//                         >
//                           <GrShare />
//                         </button>
//                       )}
//                     </td> */}

//                     <td className="text-center">
//                       <button
//                         type="button"
//                         className="action_button"
//                         onClick={() => reDirectHandler(el)}
//                         disabled={el?.surveyStatus === "draft"}
//                       >
//                         <GrShare />
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan={8}>
//                     <NotFoundPlaceHolder
//                       className="mySurveyList"
//                       title="Survey list not found"
//                       placeHolderImage={surveyPlaceholderImg}
//                     />
//                   </td>
//                 </tr>
//               ))}
//           </tbody>
//         </table>
//       </div>
//     </InfiniteScroll>
//   );
// };
